import { WordCloudComponent } from '../charts/word-cloud-component'

export class SDWordCloud extends WordCloudComponent {
 static config = {
  selector: 'sdWordCloud',
  controller: SDWordCloud,
  bindings: WordCloudComponent.config.bindings,
  template: WordCloudComponent.config.template,
 }

 setProperties() {
  this.seriesTitle = 'Occurences'
  this.seriesColors = this.properties.colorPalette
  this.maxPhraseLength = 20
 }
}
